import { Formik } from 'formik'
import { ButtonBlue } from 'components/common'
import { default as Cookies } from 'js-cookie'
import { useState, useEffect } from "react";
import { React, styled, Yup, mq } from 'x'
import {
  compose,
  lifecycle,
  pure,
  withHandlers,
  withState,
  withProps,
} from 'recompose'
import ip from 'library/ip'

import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import {
  getCountries,
  getCountryCallingCode,
} from 'react-phone-number-input/input'
import en from 'react-phone-number-input/locale/en.json'

import Arrow from '../static/svg/arrow.svg'

const DefaultFormWrapper = styled.form`
  transition:all 0.3s ease-in-out;
  display: flex;
  flex-flow: wrap;
  width: calc(100% + 50px);

  .PhoneInputCountry {
    background: #fff;
    padding: 15px;
    border-bottom: 3px solid ${(props) => props.theme.primaryRGBA(0.2)};

    --PhoneInputCountrySelectArrow-color: #000;
    --PhoneInputCountrySelectArrow-color--focus: #000;
    --PhoneInputCountryFlag-borderColor: #000;
  }

  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
    box-shadow: none;
  }

  .PhoneInputCountryIcon {
    border: none;
    box-shadow: none;
    background: transparent;
    font-size: 15px;
    width: auto;
  }

  .PhoneInputCountryIcon--border {
    border: none;
    box-shadow: none;
  }
`



const DefaultSubmitButton = styled(ButtonBlue)`
  margin-top: 35px;
`

const DefaultFieldGroup = styled.div`
  width: ${(props) => (props.fullWidth ? '100%' : 'calc(50% - 50px)')};
  margin-right: 50px;
  margin-bottom: 35px;

  label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    line-height: 10px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: ${(props) => props.theme.primary};
    margin-bottom: 18px;
  }

  input[type='text'],
  input[type='email'],
  input[type='tel'],
  select,
  textarea {
    padding: 15px 15px;
    background: #fff;
    border: none;
    border-bottom: 3px solid ${(props) => props.theme.primaryRGBA(0.2)};
    font-size: 15px;
    line-height: 26px;
    width: 100%;
    box-sizing: border-box;
  }

  input,
  textarea {
    outline: none;
  }

  input.error,
  textarea.error {
    border-color: rgba(255, 0, 0, 0.6);
  }

  ${mq.below('lg')} {
    box-sizing: border-box;
    width: 100%;
    padding: 0 15px 0 0;
  }
`

export const DefaultFieldHeader = styled.p`
  position: relative;
  line-height: 16px;
  display: block;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.primary};
  margin-bottom: 28px;
`

const BusinessEnquiry = styled.div`
  ${DefaultFieldHeader} {
    margin-bottom: 20px;
  }
`

const BusinessEnquiryNew = styled.div`
  ${DefaultFieldHeader} {
    margin-bottom: 20px;
  }
  width:100%;
  display:flex;
  flex-wrap: wrap;

  & > div {
    @media screen and (max-width: 60em) {
      flex:1 1 100%;
      width: 100%;
      max-width:100%;
    }
    flex:1 1 calc(50% - 50px);
    width: calc(50% - 50px);
    max-width:calc(50% - 50px);
  }

  &.inactive {
    visibility: hidden;
    opacity:0;
    height:0;
    transition: all 0.3s ease-in-out;
  }

  &.active {
    visibility: visible;
    opacity:1;
    height:100%;
  }

  select {
    padding:15px !important;
  }
`

export const DefaultRadioFieldGroup = styled(DefaultFieldGroup)`
  display: flex;
  align-items0: center;
  padding-top: 8px;
  position: relative;
  box-sizing: border-box;

  label {
    position: relative;
    margin-bottom: 0;
    padding-left: 45px;
    line-height: 16px;
    margin-right: 40px;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .bullet {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 30px;
    width: 30px;
    background-color: #fff;
    border-radius: 20px;
  }
  .bullet:after {
    content: '';
    position: absolute;
    display: none;
    left: 8px;
    top: 8px;
    width: 14px;
    height: 14px;
    border-radius: 20px;
    background-color: ${(props) => props.theme.primary};
  }
  label:hover input ~ .bullet:after {
    display: block;
    background-color: ${(props) => props.theme.primaryRGBA(0.2)};
  }
  label input:checked ~ .bullet {
    background-color: ${(props) => props.theme.primary};
  }
  label input:checked ~ .bullet:after {
    display: block;
    background-color: #fff;
  }
`

export const DefaultCheckboxFieldGroup = styled(DefaultFieldGroup)`
  display: flex;
  align-items: center;
  padding-top: 8px;
  position: relative;
  box-sizing: border-box;

  label {
    position: relative;
    margin-bottom: 0;
    padding-left: 45px;
    line-height: 16px;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 25px;
    width: 25px;
    background-color: #fff;
  }
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  &:hover input ~ .checkmark:after {
    display: block;
    border-color: ${(props) => props.theme.primaryRGBA(0.2)};
  }
  input:checked ~ .checkmark {
    background-color: ${(props) => props.theme.primary};
  }
  input:checked ~ .checkmark:after {
    display: block;
    border-color: #fff;
  }
`

export const DefaultOptInCheckboxFieldGroup = styled(DefaultFieldGroup)`
  display: flex;
  flex-direction: column;
  padding-top: 8px;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 0;
  padding-top: 0;

  label {
    position: relative;
    margin-bottom: 0;
    padding-left: 45px;
    line-height: 16px;
    text-transform: none;
    color: #fff;
    a {
      color: ${(props) => props.theme.primary};
      text-decoration: underline;
    }
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 25px;
    width: 25px;
    background-color: #fff;
  }
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  &:hover input ~ .checkmark:after {
    display: block;
    border-color: ${(props) => props.theme.primaryRGBA(0.2)};
  }
  input:checked ~ .checkmark {
    background-color: ${(props) => props.theme.primary};
  }
  input:checked ~ .checkmark:after {
    display: block;
    border-color: #fff;
  }
`

const DefaultError = styled.div`
  color: #fff;
  background: rgba(255, 0, 0, 0.6);
  padding: 10px;
`

export const OptIn = styled.div`
  display: flex;
  flex-flow: column;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.7);
`

export const FieldContainer = styled.div`
  display: flex;
  flex-flow: column;
  padding-top: 10px;
  border-top: 0px solid rgba(255, 255, 255, 0.7);
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #2A2D58;
`

const flags = {}
getCountries().forEach((country) => {
  flags[country] = () => <span>+{getCountryCallingCode(country)}</span>
})

const labels = {}
getCountries().forEach((country) => {
  labels[country] = `${en[country]} (+${getCountryCallingCode(country)})`
})

const defaults = {
  FormWrapper: DefaultFormWrapper,
  SubmitButton: DefaultSubmitButton,
  FieldGroup: DefaultFieldGroup,
  Error: DefaultError,
  CheckboxFieldGroup: DefaultCheckboxFieldGroup,
  FieldHeader: DefaultFieldHeader,
  enableFundedByCompany: true,
  enableComment: false,
  enableCorporate: true,
  RadioFieldGroup: DefaultRadioFieldGroup,
  formType: '',
}

export const CreateForm = (params) => {
  const {
    FormWrapper,
    SubmitButton,
    FieldGroup,
    Error,
    CheckboxFieldGroup,
    FindOutMore,
    enableFundedByCompany,
    enableComment,
    enableCorporate,
    FieldHeader,
    RadioFieldGroup,
  } = Object.assign(defaults, params)

  const enhance = compose(
    pure,
    withState('prevent', 'setPrevent', true),
    withState('ipData', 'setIP', undefined),
    withProps({ formID: Math.random().toString(36).substr(2, 9) }),
    withHandlers(() => {
      let formRef
      return {
        registerChild: () => (ref) => {
          formRef = ref
        },
        formSubmit: (props) => (event, submitForm) => {
          // Only pass through Formik if prevent state is true
          if (props.prevent) {
            event.preventDefault()
            submitForm()
          }
        },
        onSubmit: (props) => async (values, formik) => {
          const {
            'Email': em,
            'First Name': fn,
            'Contact Name': ln,
            'Phone': ph,
            'Subject': subject,
            'Description': description,
            'Issue': issue,
            'Student LP number': studentLPnumber,
          } = values
          console.log('Values:'+em  + ' -' + fn +' - '+ ln+' - '+ ph + ' '+ subject + ' '+ description + studentLPnumber + issue);
          console.log(values);
          dataLayer.push({
            em,
            fn,
            ln,
            ph,
            subject,
            studentLPnumber,
            issue,
          })

          // TODO _gaq.push(['_trackEvent', 'enquiry', this.getAttribute('data-formId')]);

          for (const [key, value] of Object.entries(values)) {
            // Checbox value, change to "on"
            if (value === true) {
              formik.setFieldValue(key, 'on')
            }
          }

          formik.setFieldValue(
            'LEADCF14',
            `http://www.ip-adress.com/ip_tracer/${props.ipData.ip}`,
            false
          )
          //formik.setFieldValue('Phone', values.Phone, false)

          // Coming here means form validation is successful
          // Disable setPrevent so form submission is not prevented and resubmit form, browser will handle the rest
          setTimeout(() => {
            props.setPrevent(false)
            formRef.submit()
          }, 100)
        },
      }
    }),
    lifecycle({
      componentDidMount() {
        // In case of offerForm load ip and set returned promise globally on window so it only happens once
        if (this.props.isShown === undefined) {
          if (!window.load_ip) {
            window.load_ip = ip()
          }

          let setIP = this.props.setIP
          window.load_ip.then((data) => {
            setIP(data)
          })
        }
      },
      componentDidUpdate(prevProps) {
        if (this.props.isShown && !prevProps.isShown) {
          let setIP = this.props.setIP
          ip().then((data) => {
            // c onsole.log('got data', data)
            setIP(data)
          })
        }
      },
    })
  )

  const Form = (props) => {
    const formID = props.formID

    const fieldNameOverrides =
      {
        en: {
          LEADCF10: '',
        },
        au: {
          LEADCF4: 'LEADCF2',
          LEADCF5: 'LEADCF4',
          LEADCF6: 'LEADCF3',
          LEADCF7: 'LEADCF1',
          LEADCF14: 'LEADCF10',
          LEADCF10: '',
          LEADCF133: 'LEADCF109',
          LEADCF137: 'LEADCF104',
          LEADCF104: 'LEADCF103',
          LEADCF134: 'LEADCF108',
          LEADCF106: 'LEADCF110',
          LEADCF105: 'LEADCF101',
          LEADCF135: 'LEADCF107',
          LEADCF188: 'LEADCF28',
          LEADCF241: 'LEADCF105',
          LEADCF244: 'LEADCF131',

          LEADCF316: 'LEADCF36',
        },
      }[props.globalData.language.code] || {}

    const overrideOrDefault = (name) => fieldNameOverrides[name] || name

    // Corporate Filed Toggle State
    const [CorporateActive, setCorporateActive] = useState(false);

    const handleOnToggleCorporate = () => {
      setCorporateActive(!CorporateActive);
    };

    const closeCorporate = () => {
      setCorporateActive(false);
    };

    useEffect(() => {
      setCorporateActive(false);
    }, []);
    
    
    return (
      <Formik
        initialValues={{
          'First Name': '',
          'Contact Name': '',
          Email: '',
          Phone: '',
          Country: '',
          [overrideOrDefault('LEADCF241')]: false,
          [overrideOrDefault('LEADCF244')]: false,

          [overrideOrDefault('LEADCF316')]: '',
        }}

        validationSchema={Yup.object().shape({
          'First Name': Yup.string()
            .trim()
            .required(
              props.globalData.contactRequiredFieldMessage.replace(
                '%s',
                `'${props.globalData.contactFirstName}'`
              )
            )
            .min(
              2,
              props.globalData.contactCharacterCheckMessage
                .replace('%s', `'${props.globalData.contactFirstName}'`)
                .replace('%d', 2)
            ),
          'Contact Name': Yup.string()
            .trim()
            .required(
              props.globalData.contactRequiredFieldMessage.replace(
                '%s',
                `'${props.globalData.contactLastName}'`
              )
            )
            .min(
              2,
              props.globalData.contactCharacterCheckMessage
                .replace('%s', `'${props.globalData.contactLastName}'`)
                .replace('%d', 2)
            ),
          Email: Yup.string()
            .email(props.globalData.contactInvalidEmailMessage)
            .required(
              props.globalData.contactRequiredFieldMessage.replace(
                '%s',
                `'${props.globalData.contactEmail}'`
              )
            ),
          Phone: Yup.string()
            .trim()
            .required(
              props.globalData.contactRequiredFieldMessage.replace(
                '%s',
                `'${props.globalData.contactMobileNumber}'`
              )
            )
            .test(
              'is-valid-number',
              props.globalData.contactInvalidPhoneNumber,
              (value) => isValidPhoneNumber(value)
            ),
          LEADCF133: Yup.string(),
          Company: Yup.string().when("LEADCF133", {
              is: value => value === 'on',
              then: Yup.string()
                  .trim()
                  .required(
                    props.globalData.contactRequiredFieldMessage.replace(
                      '%s',
                      `'Company'`
                    )
                  ),
          }),

          'Job Role': Yup.string().when("LEADCF133", {
            is: value => value === 'on',
            then: Yup.string()
                .trim()
                .required(
                  props.globalData.contactRequiredFieldMessage.replace(
                    '%s',
                    `'Job Role'`
                  )
                ),
          }),

          'Number of Licenses': Yup.string().when("LEADCF133", {
            is: value => value === 'on',
            then: Yup.string()
                .trim()
                .required(
                  props.globalData.contactRequiredFieldMessage.replace(
                    '%s',
                    `'Number of Licenses'`
                  )
                ),
          }),

          'Number of Employees': Yup.string().when("LEADCF133", {
            is: value => value === 'on',
            then: Yup.string()
                .trim()
                .required(
                  props.globalData.contactRequiredFieldMessage.replace(
                    '%s',
                    `'Number of Employees'`
                  )
                ),
          }),

          'Country': Yup.string().when("LEADCF133", {
            is: value => value === 'on',
            then: Yup.string()
                .trim()
                .required(
                  props.globalData.contactRequiredFieldMessage.replace(
                    '%s',
                    `'Country'`
                  )
                ),
          }),
        })}
        onSubmit={props.onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          submitForm,
          isSubmitting,
          setFieldValue,
        }) => {
          const formId = props.globalData.zohoFormId
          const salesIq = props.globalData.zohoSalesIq
          const extraField = props.globalData.zohoExtraFormField
          let thankYouPage = `${props.globalData.siteUrl}${props.globalData.thankYouPageUrl}`
          thankYouPage += `?email=${encodeURIComponent(values['Email'])}`
          thankYouPage += `&firstname=${encodeURIComponent(
            values['First Name']
          )}`
          thankYouPage += `&lastname=${encodeURIComponent(values['Contact Name'])}`
          thankYouPage += `&phone=${encodeURIComponent(values['Mobile'])}`
          thankYouPage += `&LEADCF256=${encodeURIComponent(values['LEADCF256'])}`

          const utmSource = Cookies.get('utm_source') || 'direct'
          const utmMedium = Cookies.get('utm_medium')
          const utmCampaign = Cookies.get('utm_campaign')
          const gclid = Cookies.get('gclid')

          const campaignId = Cookies.get('campaign_id')

          let gclidValue = ''
          if (gclid && gclid !== 'undefined' && gclid !== '-') {
            gclidValue = gclid
          }

          const leadFields = {
            five: '',
            six: '',
            seven: '',
          }

          if (utmSource) {
            leadFields.five = utmSource
            leadFields.six = utmMedium
            leadFields.seven = utmCampaign
          }

          var zohoAdwordsTerm = '-'
          var zohoAdwordsContent = '-'
          if (props.urlParams && props.urlParams !== 'undefined') {
            const params = new URLSearchParams(props.urlParams.search)
            zohoAdwordsTerm = params.get('utm_term')
            zohoAdwordsContent = params.get('utm_content')
          }

          return (
            <FormWrapper
              className="fmt-form contact-form"
              id="zsWebToCase_191996000033493492"
              ref={props.registerChild}
              action={'https://desk.zoho.com/support/WebToCase'}
              // action=""
              name={salesIq}
              method="post"
              data-formid={formId}
              onSubmit={(event) => props.formSubmit(event, submitForm)}
              siq_id={`autopick_9257-${formID}`}
            >
              {FindOutMore && (
                <FindOutMore>{props.globalData.stringFindOutMore}</FindOutMore>
              )}


<input type="hidden" name="xnQsjsdp" value="edbsn7deb2bd04f2fe205540f2057ab79ea46"></input>
  <input type="hidden" name="xmIwtLD" value="edbsnc8625df606c72f798bd07a201abd05a56ae6720caa56055be81d83d0e554b2e6"></input> 
  <input type="hidden" name="xJdfEaS" value=""></input>  
  <input type="hidden" name="actionType" value="Q2FzZXM="></input>
  <input type="hidden" id="property(module)" value="Cases"></input>
  <input type="hidden" id="dependent_field_values_Cases" value="{&quot;JSON_VALUES&quot;:{},&quot;JSON_SELECT_VALUES&quot;:{},&quot;JSON_MAP_DEP_LABELS&quot;:[]}"></input>

              <input
                type="hidden"
                name="returnURL"
                value={`${props.globalData.siteUrl}${props.urlParams.pathname}`}
                readOnly
              />




              <FieldGroup>
                <label htmlFor={`form-firstname-${formID}`}>
                  {props.globalData.contactFirstName}
                </label>
                <input
                  id={`form-firstname-${formID}`}
                  type="text"
                  name="First Name"
                  placeholder=""
                  minLength="2"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values['First Name']}
                  className={
                    errors['First Name'] && touched['First Name'] ? 'error' : ''
                  }
                />
                {errors['First Name'] && touched['First Name'] && (
                  <Error>{errors['First Name']}</Error>
                )}
              </FieldGroup>
              <FieldGroup>
                <label htmlFor={`form-surname-${formID}`}>
                  {props.globalData.contactLastName}
                </label>
                <input
                  id={`form-surname-${formID}`}
                  type="text"
                  name="Contact Name"
                  placeholder=""
                  minLength="2"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values['Contact Name']}
                  className={
                    errors['Contact Name'] && touched['Contact Name'] ? 'error' : ''
                  }
                />
                {errors['Contact Name'] && touched['Contact Name'] && (
                  <Error>{errors['Contact Name']}</Error>
                )}
              </FieldGroup>
              <FieldGroup>
                <label htmlFor={`form-email-${formID}`}>
                  {props.globalData.contactEmail}
                </label>
                <input
                  id={`form-email-${formID}`}
                  type="email"
                  name="Email"
                  placeholder=""
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.Email}
                  className={errors.Email && touched.Email ? 'error' : ''}
                />
                {errors.Email && touched.Email && <Error>{errors.Email}</Error>}
              </FieldGroup>
              <FieldGroup>
                <label htmlFor={`form-mobile-${formID}`}>
                  {props.globalData.contactMobileNumber}
                </label>
                <input type="hidden" name="Phone" value={values.Mobile} />
                <PhoneInput
                  placeholder={props.globalData.contactPreferredNumber}
                  name="Phone"
                  flags={flags}
                  labels={labels}
                  defaultCountry={
                    props.ipData?.country_code
                      ? props.ipData.country_code
                      : props.post?.language?.code
                      ? props.post.language.code === 'en'
                        ? 'GB'
                        : 'AU'
                      : null
                  }
                  onChange={(value) => {
                    setFieldValue('Phone', value, true)
                  }}
                  onBlur={handleBlur}
                  value={values.Phone}
                  className={errors.Phone && touched.Phone ? 'error' : ''}
                />
                {errors.Phone && touched.Phone && (
                  <Error>{errors.Phone}</Error>
                )}
              </FieldGroup>

              <FieldGroup>
                <label htmlFor={`form-firstname-${formID}`}>
                  Student LP Number
                </label>
                <input
                  id={`form-Student-LP-number-${formID}`}
                  type="text"
                  name="Student LP number"
                  placeholder=""
                  minLength="2"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values['Student LP number']}
                  className={
                    errors['Student LP number'] && touched['Student LP number'] ? 'error' : ''
                  }
                />
                {errors['Student LP number'] && touched['Student LP number'] && (
                  <Error>{errors['Student LP number']}</Error>
                )}
              </FieldGroup>    

                <FieldGroup>
                <label htmlFor={`form-Issue-${formID}`}>Issue</label>
                <select className={
                      errors['Issue'] && touched['Issue'] ? 'error zcwf_col_fld_slt' : 'zcwf_col_fld_slt'
                    } id='Issue' name='Issue' onChange={handleChange}
                    onBlur={handleBlur} style={{padding: '10px 5px'}}><option value='None'>None</option>
                    <option value='Exam Query/ voucher'>Exam Query/ voucher</option>
                    <option value='Reschedule orientation'>Reschedule orientation</option>
                    <option value='Totum/ Student Card'>Totum/ Student Card</option>
                    <option value='AUZ/ NZL'>AUZ/ NZL</option>
                    <option value='Technical Issue'>Technical Issue</option>
                    <option value='Class'>Class</option>
                    <option value='Learning Support'>Learning Support</option>
                    <option value='Other'>Other</option>
                    </select>
                    {
                      errors['Issue'] && touched['Issue'] && (
                        <Error>{errors['Issue']}</Error>
                      )}
                 
                </FieldGroup>    

              <FieldGroup>
                <label htmlFor={`form-Subject-${formID}`}>
                Subject
                </label>
                <input
                  id={`form-Subject-LP-number-${formID}`}
                  type="text"
                  name="Subject"
                  placeholder=""
                  minLength="2"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values['Subject']}
                  className={
                    errors['Subject'] && touched['Subject'] ? 'error' : ''
                  }
                />
                {errors['Subject'] && touched['Subject'] && (
                  <Error>{errors['Subject']}</Error>
                )}
              </FieldGroup>    

                <FieldGroup fullWidth>
                  <label htmlFor={`form-Description-${formID}`}>
                    Description
                  </label>
                  <textarea
                    id={`form-Description-${formID}`}
                    type="text"
                    name="Description"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values['Description']}
                    className={
                      errors['Description'] &&
                      touched['Description']
                        ? 'error'
                        : ''
                    }
                  />
                  {errors[overrideOrDefault('LEADCF188')] &&
                    touched[overrideOrDefault('LEADCF188')] && (
                      <Error>{errors[overrideOrDefault('LEADCF188')]}</Error>
                    )}
                </FieldGroup>                                                 

              {/*<FieldGroup>*/}
              {/*  <label htmlFor={`form-telephone-${formID}`}>{ props.globalData.contactLandlineNumber }</label>*/}
              {/*  <input id={`form-telephone-${formID}`}*/}
              {/*         type="tel"*/}
              {/*         name="Phone"*/}
              {/*         placeholder={ props.globalData.contactIncAreaAndCountryCode }*/}
              {/*         onChange={ handleChange }*/}
              {/*         onBlur={ handleBlur }*/}
              {/*         value={ values.Phone }*/}
              {/*  />*/}
              {/*</FieldGroup>*/}
              {enableComment && (
                <FieldGroup fullWidth>
                  <label htmlFor={`form-comment-${formID}`}>
                    {props.globalData.contactComment}
                  </label>
                  <textarea
                    id={`form-comment-${formID}`}
                    type="text"
                    name={overrideOrDefault('LEADCF188')}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values[overrideOrDefault('LEADCF188')]}
                    className={
                      errors[overrideOrDefault('LEADCF188')] &&
                      touched[overrideOrDefault('LEADCF188')]
                        ? 'error'
                        : ''
                    }
                  />
                  {errors[overrideOrDefault('LEADCF188')] &&
                    touched[overrideOrDefault('LEADCF188')] && (
                      <Error>{errors[overrideOrDefault('LEADCF188')]}</Error>
                    )}
                </FieldGroup>
              )}




            
              {/* <OptIn>
                <OptInCheckboxFieldGroup>
                  <label htmlFor={`checkbox-optin1-${formID}`}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: props.globalData.contactOptin1,
                      }}
                    />
                    <input
                      id={`checkbox-optin1-${formID}`}
                      type="checkbox"
                      name={overrideOrDefault('LEADCF241')}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values[overrideOrDefault('LEADCF241')]}
                    />
                    <span className="checkmark" />
                  </label>
                  {errors[overrideOrDefault('LEADCF241')] &&
                    touched[overrideOrDefault('LEADCF241')] && (
                      <Error>{errors[overrideOrDefault('LEADCF241')]}</Error>
                    )}
                </OptInCheckboxFieldGroup>
                <OptInCheckboxFieldGroup>
                  <label htmlFor={`checkbox-optin2-${formID}`}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: props.globalData.contactOptin2,
                      }}
                    />
                    <input
                      id={`checkbox-optin2-${formID}`}
                      type="checkbox"
                      name={overrideOrDefault('LEADCF244')}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values[overrideOrDefault('LEADCF244')]}
                    />
                    <span className="checkmark" />
                  </label>
                </OptInCheckboxFieldGroup>
              </OptIn> */}
              <SubmitButton
              id="zsSubmitButton_191996000033493492"
                as="button"
                type="submit"
                disabled={isSubmitting}
                className={do {
                  const formType = props.formType || params.formType
                  // c onsole.log('formType', formType)
                  if (formType === 'bubble') 'submit-contact-bubble'
                  else if (formType === 'contactUs') 'submit-contact-us'
                  else if (formType === 'offer') `submit-offer-form`
                  else `submit-${formType}`
                }}
              >
                {props.globalData.contactSubmit}
                <Arrow className="circle" />
              </SubmitButton>
            </FormWrapper>
          )
        }}
      </Formik>
    )
  }

  return enhance(Form)
}

export default CreateForm()
